import { render, staticRenderFns } from "./panelHeader.vue?vue&type=template&id=4b02df47&scoped=true"
import script from "./panelHeader.vue?vue&type=script&lang=js"
export * from "./panelHeader.vue?vue&type=script&lang=js"
import style0 from "./panelHeader.vue?vue&type=style&index=0&id=4b02df47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b02df47",
  null
  
)

export default component.exports